/**
 * General behaviours
 */
Drupal.behaviors.rmccMisc = {
  attach(context, settings) {
    if ($('.manual-address', context).length !== 0) {
      return;
    }
    $(document).on('click', 'a:not(.js-toggle-star-found)', function (event) {
      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 50
      }, 500);
    });
  }
};
